import { Box, Skeleton } from "@mui/material";
import { CALIBRATE_SURFACE_HAIRLINE } from "components/hoc/Theme";

export default function PartnerCardSkeleton() {
  return (
    <Box
      sx={{
        position: "relative",
        aspectRatio: "1 / 1",
        borderRadius: "10px",
        border: `1px solid ${CALIBRATE_SURFACE_HAIRLINE}`,
        backgroundColor: "background.paper",
        p: "14px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Logo placeholder */}
      <Box
        sx={{
          height: "80px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mt: "30px",
        }}
      >
        <Skeleton
          variant="rectangular"
          width={80}
          height={72}
          sx={{ borderRadius: "4px" }}
        />
      </Box>

      {/* Title placeholder */}
      <Box sx={{ mt: 2 }}>
        <Skeleton
          variant="text"
          width="80%"
          height={24}
          sx={{ borderRadius: "4px" }}
        />
      </Box>

      {/* Description placeholder */}
      <Box sx={{ mt: 1 }}>
        <Skeleton
          variant="text"
          width="100%"
          height={16}
          sx={{ borderRadius: "4px" }}
        />
        <Skeleton
          variant="text"
          width="70%"
          height={16}
          sx={{ mt: 0.5, borderRadius: "4px" }}
        />
      </Box>

      {/* Badges placeholder */}
      <Box
        sx={{
          display: "flex",
          gap: "4px",
          mt: 2,
          mb: 2,
        }}
      >
        <Skeleton
          variant="rounded"
          width={80}
          height={24}
          sx={{ borderRadius: "12px" }}
        />
        <Skeleton
          variant="rounded"
          width={80}
          height={24}
          sx={{ borderRadius: "12px" }}
        />
      </Box>

      {/* Learn More placeholder */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          mt: "auto",
        }}
      >
        <Skeleton
          variant="text"
          width={80}
          height={16}
          sx={{ borderRadius: "4px" }}
        />
        <Skeleton variant="circular" width={16} height={16} />
      </Box>
    </Box>
  );
}
